import { useEffect, useRef, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../lib/api";

// Carga y gestiona reCAPTCHA v2/v3 según la config pública del servidor (mode: off|v2|v3|both)
export function useRecaptcha() {
  const [config, setConfig] = useState({ mode: "off" });
  const widgetRef = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    axios.get(`${API}/recaptcha/config`).then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const { mode, v2_site_key, v3_site_key } = config;
    if (mode === "off") return;
    const render = mode === "v2" ? "explicit" : v3_site_key;
    if (!document.getElementById("grecaptcha-script")) {
      const s = document.createElement("script");
      s.id = "grecaptcha-script";
      s.src = `https://www.google.com/recaptcha/api.js?render=${render}`;
      s.async = true;
      document.head.appendChild(s);
    }
    if ((mode === "v2" || mode === "both") && v2_site_key) {
      const t = setInterval(() => {
        if (window.grecaptcha?.render && widgetRef.current && widgetId.current === null) {
          try {
            widgetId.current = window.grecaptcha.render(widgetRef.current, { sitekey: v2_site_key });
            clearInterval(t);
          } catch { /* reintenta */ }
        }
      }, 400);
      return () => clearInterval(t);
    }
  }, [config]);

  const getTokens = useCallback(async () => {
    const { mode, v3_site_key } = config;
    const out = {};
    if (mode === "off") return out;
    if (mode === "v2" || mode === "both") {
      const v2 = widgetId.current !== null ? window.grecaptcha?.getResponse(widgetId.current) : "";
      if (!v2) throw new Error("Completa la casilla \"No soy un robot\"");
      out.v2 = v2;
    }
    if (mode === "v3" || mode === "both") {
      await new Promise((res) => window.grecaptcha?.ready ? window.grecaptcha.ready(res) : res());
      out.v3 = await window.grecaptcha.execute(v3_site_key, { action: "login" });
    }
    return out;
  }, [config]);

  const reset = useCallback(() => {
    if (widgetId.current !== null) window.grecaptcha?.reset(widgetId.current);
  }, []);

  return { config, widgetRef, getTokens, reset };
}
